import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import { FormattedMessage } from 'i18n';
import b from 'i18n/richTextFormats/b';
import PromoHeader from 'components/common/promoHeader/PromoHeader';
import ActivityWidget from 'components/activityWidget/ActivityWidget';
import Checkmarks from 'routes/_components/layout/components/footer/components/checkmarks/Checkmarks';
import Spinner from 'routes/template/components/Spinner';
import IntroSection from 'routes/template/components/IntroSection/IntroSection';
// import DestinationLinks from 'components/banner/banners/destinationLinks/DestinationLinks';
import TemplatesMap from 'components/map/TemplatesMap';
import { mediaQueries } from 'styles/utils/mediaQueries';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import InfiniteThreeDots from 'components/spinners/InfiniteThreeDots';
import { getDestinationHelper } from './destinationTemplateHelper';

const RecommendedHotels = loadableVisibility(() => import('components/recommendedHotels/RecommendedHotels'), {
  fallback: <InfiniteThreeDots />,
});

function DestinationTemplateComponent({
  content,
  countHotels,
  hotels,
  destinationMap,
  recommendedHotelsLabel,
  showSpinner,
  onClickSeeAllHotels,
}) {
  const image = content.gallery && content.gallery[0] && content.gallery[0].url;
  const destination = getDestinationHelper(content);

  return (
    <Fragment>
      <PromoHeader
        image={image}
        title={content.title}
        subtitle={
          <FormattedMessage
            id={'destinationCard.component.numberOfHotels.label'}
            description={'<b>{number}</b> { number, plural, one {hotel} other {hotels} }'}
            defaultMessage={'<b>{number}</b> { number, plural, one {hotel} other {hotels} }'}
            values={{ b, number: countHotels }}
          />
        }
        buttonLabel={
          <FormattedMessage
            id={'countryTemplate.component.seeAllHotels.label'}
            description={'See all hotels'}
            defaultMessage={'See all hotels'}
          />
        }
        onClickButton={onClickSeeAllHotels}
      />
      <Root>
        <IntroSectionWrap>
          <IntroSection title={content.title} description={content.description} />
        </IntroSectionWrap>
        {/* {destinationMap && <DestinationLinks destinationCode={destinationMap[0].code} />} */}
        {showSpinner ? (
          <Spinner />
        ) : (
          <MapSectionWrap>
            <TemplatesMap hotels={hotels} />
          </MapSectionWrap>
        )}
      </Root>

      <Margin top='5' />
      <RecommendedHotels destinations={destinationMap} label={recommendedHotelsLabel} />
      <Margin top='5' />
      {destinationMap && <ActivityWidget destination={destination} />}
      <Checkmarks hideHighlights />
    </Fragment>
  );
}

export default DestinationTemplateComponent;

const Root = styled.div`
  width: 1024px;
  margin: 0 auto;
  padding: 0 15px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 750px;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
  `}
`;

const SectionWrap = styled.div`
  margin: 100px 0 0;
`;

const IntroSectionWrap = styled(SectionWrap)``;

const MapSectionWrap = styled(SectionWrap)`
  ${mediaQueries.fromAndBelow.tablet`
    margin-top: 50px;
  `}
`;
